module.exports = __webpack_public_path__ + "img/empty_flex.a7dd9cfc.svg";